var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66732 4.16684L6.62866 5.32646C7.77213 6.00252 8.22917 6.00252 9.37264 5.32646L11.334 4.16684M6.06653 0.857871C7.36019 0.82537 8.64111 0.825371 9.93477 0.857875C12.0338 0.910614 13.0833 0.936984 13.8374 1.69394C14.5914 2.45089 14.6132 3.47274 14.6568 5.51643C14.6708 6.17355 14.6708 6.82679 14.6568 7.48391C14.6132 9.5276 14.5914 10.5494 13.8374 11.3064C13.0833 12.0634 12.0338 12.0897 9.93477 12.1425C8.64111 12.175 7.36019 12.175 6.06654 12.1425C3.96754 12.0897 2.91804 12.0634 2.16396 11.3064C1.40987 10.5494 1.38808 9.5276 1.34449 7.48391C1.33048 6.82679 1.33048 6.17354 1.34449 5.51642C1.38808 3.47273 1.40987 2.45088 2.16395 1.69393C2.91804 0.936972 3.96754 0.910605 6.06653 0.857871Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.fdaa29eca6df34569a5aad4da8c90f89.svg";
export { ForwardRef as ReactComponent };